import { hashKey } from '@tanstack/react-query';

// here is our little pending promises cache mechanism

// if there are multiple imperative fetchMore calls for with same query params
// then while the first one is still pending
// we will reuse the result of the first for all of them

export function withSamePromiseWhilePending<T extends (...args: any[]) => Promise<any>>(
    factory: T,
): T {
    const cache: Record<string, Promise<any>> = {};

    const result = (...args: Parameters<T>[]): Promise<any> => {
        const hash = hashKey(args);

        const cached = cache[hash];

        if (cached) {
            return cached;
        }

        const promise = factory(...args).finally(() => {
            delete cache[hash];
        });

        cache[hash] = promise;

        return promise;
    };

    return result as T;
}
